import { render, staticRenderFns } from "./StatusPending.vue?vue&type=template&id=8b57d14c&"
import script from "./StatusPending.vue?vue&type=script&lang=js&"
export * from "./StatusPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports